import type { Unsubscriber } from "svelte/store";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function useTimeout(callback: () => void, delay: number): () => void {
  const id = setTimeout(callback, delay);
  const cancel = (): void => clearTimeout(id);

  /*                                                                                                                                       */
  $effect(() => cancel);

  /*                                                                */
  return cancel;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type CreateSetTimeout<Cb extends TimerHandler | undefined> = undefined extends Cb
  ? (callback: TimerHandler, concreteTimeout?: number) => Unsubscriber
  : (callback?: Cb, concreteTimeout?: number) => Unsubscriber;

/**
 *
 *
 *
 *
 *
 *
 */
export const useTimeoutEx: <Cb extends TimerHandler | undefined>(
  defaultCallback?: Cb,
  defaultTimeout?: number,
) => CreateSetTimeout<Cb> = (defaultCallback, defaultTimeout) => {
  let currentId = -1;

  /*                                    */
  const unset = (): void => clearTimeout(currentId);

  /*                                                       */
  /*                                                                                                            */
  $effect(unset);

  return ((callback = defaultCallback, timeout = defaultTimeout) => {
    unset();
    currentId = window.setTimeout(callback!, timeout);
    return unset;
  }) as never;
};
